import { Alert, Box, Typography } from '@mui/material';
import { useSearchDomains } from '../../hooks/api/use-domains.hook';
import { OntologyAttributeUpdatedEvent } from '../../../../types/models/event/ontology.event';
import { convertCamelCaseToUserFriendly } from '../../utils/casing';

interface Props {
  details: OntologyAttributeUpdatedEvent['details'];
}

export const OntologyAttributeUpdatedEventDetails = ({ details }: Props) => {
  const { response: domains, error: getDomainsError } = useSearchDomains(
    { id: details.update.domains ? details.update.domains.map(({ id }) => id) : undefined },
    Boolean(details.update.domains),
  );

  const renderUpdateProperty = (property: keyof OntologyAttributeUpdatedEvent['details']['update']) => {
    if (property === 'domains') {
      return (
        <Typography sx={{ pl: 5 }}>{`${domains?.pages
          .flatMap(({ result }) => result)
          .map(({ name }) => name)
          .join(', ')}`}</Typography>
      );
    }

    return <Typography sx={{ pl: 5 }}>{`${details.update[property]}`}</Typography>;
  };

  if (getDomainsError) {
    return <Alert severity="error">{getDomainsError.response?.data?.message}</Alert>;
  }

  return Object.entries(details ?? {})?.map(([detailName, value]) => (
    <Box key={detailName} display="flex" flexDirection={typeof value === 'object' ? 'column' : 'row'}>
      <Typography sx={{ fontWeight: 'bold' }}>{`${convertCamelCaseToUserFriendly(detailName)}:`}</Typography>
      {typeof value === 'object' ? (
        Object.keys(value ?? {})?.map((objectKey) => (
          <Box key={objectKey} display="flex">
            <Typography
              sx={{ pl: 2, fontWeight: 'bold' }}
            >{`${convertCamelCaseToUserFriendly(objectKey)}:`}</Typography>
            <Box flexGrow={1} />
            {renderUpdateProperty(objectKey as keyof OntologyAttributeUpdatedEvent['details']['update'])}
          </Box>
        ))
      ) : (
        <>
          <Box flexGrow={1} />
          <Typography sx={{ pl: 10 }}>{`${value}`}</Typography>
        </>
      )}
    </Box>
  ));
};
